import { CLIENT_ERROR_LIMITS, CLIENT_ERRORS_MAX_BYTES, CLIENT_ERRORS_ROUTE, } from "@repo/contract";
/** Stand-in for an empty bundle version, which the contract refuses. */
const UNKNOWN_BUNDLE = "unknown";
const encoder = new TextEncoder();
const TRAILING_SLASHES = /\/+$/;
function byteLength(text) {
    return encoder.encode(text).byteLength;
}
/** At most `max` UTF-16 units, never ending on half a surrogate pair. */
function cut(text, max) {
    if (text.length <= max) {
        return text;
    }
    const end = max;
    const last = text.charCodeAt(end - 1);
    // A high surrogate left alone at the end would be a lone surrogate.
    const safeEnd = last >= 0xd8_00 && last <= 0xdb_ff ? end - 1 : end;
    return text.slice(0, Math.max(0, safeEnd));
}
function isoOf(occurredAt) {
    return typeof occurredAt === "string" ? occurredAt : occurredAt.toISOString();
}
/**
 * The report with every field cut to its contract cap. Absent optional
 * fields are left out rather than sent as `undefined` or `""`.
 */
export function buildClientErrorReport(input) {
    const report = {
        bundleVersion: cut(input.bundleVersion, CLIENT_ERROR_LIMITS.bundleVersion) ||
            UNKNOWN_BUNDLE,
        message: cut(input.message, CLIENT_ERROR_LIMITS.message),
        occurredAt: isoOf(input.occurredAt),
        platform: input.platform,
        source: input.source,
    };
    if (input.stack !== undefined && input.stack !== "") {
        report.stack = cut(input.stack, CLIENT_ERROR_LIMITS.stack);
    }
    if (input.route !== undefined && input.route !== "") {
        report.route = cut(input.route, CLIENT_ERROR_LIMITS.route);
    }
    return report;
}
/**
 * The beacon's body: {@link buildClientErrorReport}, serialized, and
 * guaranteed to be at most 16 KiB of UTF-8.
 *
 * Only the STACK ever gives way. Every other field at its cap is at most
 * 2564 UTF-16 units, and a unit costs at most six bytes (a control character
 * or a lone surrogate, JSON-escaped), so they cannot pass the budget on their
 * own: about 15.2 KiB with the keys. Each step cuts at least the overflow in
 * characters (a character is at least one byte), so the loop converges in a
 * few passes.
 */
export function buildClientErrorBody(input) {
    const report = buildClientErrorReport(input);
    let body = JSON.stringify(report);
    let overflow = byteLength(body) - CLIENT_ERRORS_MAX_BYTES;
    while (overflow > 0 && report.stack !== undefined && report.stack !== "") {
        report.stack = cut(report.stack, Math.max(0, report.stack.length - overflow));
        body = JSON.stringify(report);
        overflow = byteLength(body) - CLIENT_ERRORS_MAX_BYTES;
    }
    return body;
}
/** `POST /client-errors` under the API base, with or without its trailing slash. */
export function clientErrorsUrl(apiBaseUrl) {
    return `${apiBaseUrl.replace(TRAILING_SLASHES, "")}${CLIENT_ERRORS_ROUTE}`;
}
//# sourceMappingURL=index.js.map